import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class daywiseItinerary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Event Info
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Day wise itinerary
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <section className="At_a_Glance_ITME2026_section">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Activities</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">
                                                Day Wise Itinerary - INDIA ITME 2026
                                            </span>
                                        </h2>
                                        <h5 style={{ fontWeight: 100 }}>
                                            Highlights And Concurrent Activities <br />
                                            Exhibition - 4th To 9th December 2026
                                        </h5>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt_40" data-aos="fade-up" data-aos-delay={500}>
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="DayWiseItinerary">
                                                <h6 className="activity_dates">Friday, 4th December, 2026</h6>
                                                <div className="At_Glance_section_grid_view">
                                                    <div className="title_txt">
                                                        <h6>10:00</h6>
                                                    </div>
                                                    <div className="cont_txt">
                                                        <h5>Inaugration &amp; Exhibition</h5>
                                                        {/* <p><i class="fas fa-map-marker-alt"></i> Foyer Area</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="DayWiseItinerary">
                                                <h6 className="activity_dates">Saturday, 5th December, 2026</h6>
                                                <div className="At_Glance_section_grid_view">
                                                    <div className="title_txt">
                                                        <h6>10:00 - 18:00</h6>
                                                    </div>
                                                    <div className="cont_txt">
                                                        <h5>Exhibition, Seminar Session &amp; B2B Meetings</h5>
                                                        {/* <p><i class="fas fa-map-marker-alt"></i> Emerald Room, ITME Square, 2nd Floor</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="DayWiseItinerary">
                                                <h6 className="activity_dates">Sunday, 6th December, 2026</h6>
                                                <div className="At_Glance_section_grid_view">
                                                    <div className="title_txt">
                                                        <h6>10:00 - 18:00</h6>
                                                    </div>
                                                    <div className="cont_txt">
                                                        <h5>Exhibition, Seminar Session &amp; B2B Meetings</h5>
                                                        {/* <p><i class="fas fa-map-marker-alt"></i> Emerald Room, ITME Square, 2nd Floor</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="DayWiseItinerary">
                                                <h6 className="activity_dates">Monday, 7th December, 2026</h6>
                                                <div className="At_Glance_section_grid_view">
                                                    <div className="title_txt">
                                                        <h6>10:00 - 18:00</h6>
                                                    </div>
                                                    <div className="cont_txt">
                                                        <h5>Exhibition, Seminar Session &amp; B2B Meetings</h5>
                                                        {/* <p><i class="fas fa-map-marker-alt"></i> Emerald Room, ITME Square, 2nd Floor</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="DayWiseItinerary">
                                                <h6 className="activity_dates">Tuesday, 8th December, 2026</h6>
                                                <div className="At_Glance_section_grid_view">
                                                    <div className="title_txt">
                                                        <h6>10:00 - 18:00</h6>
                                                    </div>
                                                    <div className="cont_txt">
                                                        <h5>Exhibition, Seminar Session &amp; B2B Meetings</h5>
                                                        {/* <p><i class="fas fa-map-marker-alt"></i> Emerald Room, ITME Square, 2nd Floor</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="DayWiseItinerary">
                                                <h6 className="activity_dates">
                                                    Wednesday, 9th December, 2026
                                                </h6>
                                                <div className="At_Glance_section_grid_view">
                                                    <div className="title_txt">
                                                        <h6>10:00 - 18:00</h6>
                                                    </div>
                                                    <div className="cont_txt">
                                                        <h5>Conclusion of Exhibition</h5>
                                                        {/* <p><i class="fas fa-map-marker-alt"></i> Emerald Room, ITME Square, 2nd Floor</p> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(daywiseItinerary));